//#region Libraries
import NavigateButton from "components/NavigateButton/NavigateButton";
//#endregion
//#region Styles
import { Column, Row } from "components/styles";
import { EmptyLabel } from "views/components/Schedules/components/SchedulesSkelletonContent/styles";
import SchedulesSkelletonContent from "views/components/Schedules/components/SchedulesSkelletonContent/SchedulesSkelletonContent";
//#endregion

const SchedulesSkelleton = () => {
    return (
        <Column marginTop="35px">
            <Row width="100%">
                <EmptyLabel/>
                <Row>
                    <EmptyLabel/>
                    <NavigateButton 
                        angle="90deg"
                        disabled/>
                    <NavigateButton
                        angle="270deg"
                        disabled/>
                </Row>
            </Row>
            <SchedulesSkelletonContent/>
        </Column>
    );
}

export default SchedulesSkelleton;